import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ScrollIntoView from "../../shared/scroll-into-view/scroll-into-view";
import {
  addVisualEffect,
  clearVisualEffect,
  clearRedirect,
  uploadImagesAndSaveVisualEffect,
  setName,
  setReturnUrl
} from "./ducks/actions";
import Form from "./form";

function AddVisualEffect(props) {
  const filmId = props.filmId || props.match.params.filmId;
  const sceneId = props.sceneId || props.location?.state?.sceneId;
  const returnUrl = props.location?.state?.returnUrl;

  const { addVisualEffect,
    visualEffect,
    errors,
    uploadImagesAndSaveVisualEffect,
    setName,
    name,
    embedded,
    clearVisualEffect,
    setReturnUrl,
    onCloseForm
  } = props;

  useEffect(() => {
    clearVisualEffect();
  }, []);

  useEffect(() => {
    if (name) {
      setName(name);
    }
  }, [name]);

  useEffect(() => {
    setReturnUrl(returnUrl);
  }, [returnUrl]);

  if (!embedded && props.redirect) {
    if (props.redirect.to === "list") {
      props.clearRedirect();
      const url = `/films/${filmId}/visual-effects/`;
      return <Redirect to={url} />;
    } else if (props.redirect.to === "scenes") {
      props.clearRedirect();
      const url = `/films/${filmId}/visual-effects/${props.redirect.id}/scenes/`;
      return <Redirect to={url} />;
    }
  }

  function onAddVisualEffect(prop) {
    prop.sceneId = sceneId;
    const files = prop.pictures || [];
    if (files && files.length > 0) {
      uploadImagesAndSaveVisualEffect(prop, files, true, filmId);
    } else {
      if (!prop.imageUrls) {
        prop.imageUrls = [];
      }
      addVisualEffect(filmId, prop);
    }
  }

  return (
    <ScrollIntoView
      className="blade-content widest"
      path="/films/:filmId/visual-effects/add"
      loading={false}>
      <Form
        errors={errors}
        propId={null}
        initialValues={visualEffect}
        loading={false}
        onSubmit={onAddVisualEffect}
        onCloseForm={onCloseForm}
        {...props}
        mode="add"
        reduxFormValues={props.reduxFormValues}
      />
    </ScrollIntoView>
  );
}

function mapStateToProps(state) {
  const { visualEffectsState, commonState } = state;

  return {
    visualEffect: visualEffectsState.visualEffect,
    errors: visualEffectsState.errors,
    redirect: visualEffectsState.redirect,
    acquisitionMethodEnum: commonState.acquisitionMethod
  };
}

export default connect(mapStateToProps, {
  addVisualEffect,
  clearVisualEffect,
  clearRedirect,
  uploadImagesAndSaveVisualEffect,
  setName,
  setReturnUrl
})(AddVisualEffect);
